import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import { getModule } from 'vuex-module-decorators';
import authModule from '@/store/modules/auth';
import store from '@/store';
import { type DrawerItem } from './Navigation-Drawer-Items';

interface NavigationDrawerItemProps {
  item: DrawerItem;
  displaySettingsDrawer: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Navigation-Drawer-Item',
  props: {
  item: null,
  displaySettingsDrawer: { type: Boolean }
},
  setup(__props) {

const props = __props;
const auth = getModule(authModule, store);



const isEnabled = _computed(() => props.item.actions
?.map((action) => auth.userActions[action])
.some((value) => value));
const hideElement = (e: MouseEvent) => {
  const target = e.currentTarget as HTMLElement;
  target.style.display = 'none';
  setTimeout(() => {
    target.style.display = 'block';
  }, 100);
};


return { __sfc: true,auth, props, isEnabled, hideElement, _computed, getModule, authModule, store }
}

})